import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// TODO: Replace with your Firebase project configuration
// Found in: Firebase Console → Project Settings → General → Your apps
const firebaseConfig = {
  apiKey: "AIzaSyBQfvUKlPQvc6XYGIbwOQSOyBCAxvA2ACM",
  authDomain: "vinia-9d580.firebaseapp.com",
  projectId: "vinia-9d580",
  storageBucket: "vinia-9d580.firebasestorage.app",
  messagingSenderId: "365921034498",
  appId: "1:365921034498:web:21bbb41e1b6e09bba8621b",
  measurementId: "G-3ZX2FGSTY1"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// const analytics = getAnalytics(app);
